// TODO: can this be removed? where is it used?
export const IN = "_~IN~_";
//# sourceMappingURL=constants.js.map